import React from 'react'

const Home = () => (
    <div>
        <h2>I see fire and ice.</h2>
    </div>
)

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.js